export default "__VITE_ASSET__BRT9dBHo__"